<template>
<div>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="20">
          <a-col :md="6" :sm="24">
            <a-form-item label="Query">
              <a-input v-model="queryParam.name" placeholder="Name / Number" @keyup.enter.stop="refreshCurrentPage"/>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="Gender">
              <a-select v-model="queryParam.gender" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="M">Male</a-select-option>
                <a-select-option value="F">Female</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="Website">
              <a-select v-model="queryParam.registerSite" placeholder="Please select" default-value="0" @change="refreshCurrentPage" :dropdownMatchSelectWidth="false">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="signettours.com">signettours.com</a-select-option>
                <a-select-option value="signettours.ca">signettours.ca</a-select-option>
                <a-select-option value="superatours.com">superatours.com</a-select-option>
                <a-select-option value="superatours.ca">superatours.ca</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24" v-show="false">
            <a-form-item label="Status">
              <a-select v-model="queryParam.auditStatus" placeholder="Please select" default-value="0" @change="refreshCurrentPage">
                <a-select-option value="">All</a-select-option>
                <a-select-option value="0">Pending</a-select-option>
                <a-select-option value="1">Approved</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 4 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = { name: '', gender: '', registerSite: '', auditStatus: '' }">Clear</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleEdit()" :disabled="!$auth('CDB_MEMBERSHIP_ADD')">New</a-button>
    </div> -->

    <s-table
      ref="table"
      size="default"
      rowKey="id"
      showQuickJumper
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1100 }"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="coupon" slot-scope="couponList">
        <span v-if="couponList && couponList.length > 0 && couponList[0].usageStatus === '1'">Used</span>
        <span v-else>Available</span>
      </span>
      <div slot="writeDate" slot-scope="text, row" style="display: flex;">
        <div style="font-weight:500;margin-right: 6px;">{{ row.changeBy.userName }}</div>
        <div style="width: 80px;">{{ DateTimeUtil().localString(row.writeDate !== null ? row.writeDate : row.createDate) }}</div>
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)" :disabled="!$auth('CDB_MEMBERSHIP_EDIT')">Edit</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="Are you sure delete?"
            @confirm="onDeleteConfirmed(record)"
            okText="Yes"
            cancelText="No"
          >
            <a href="javascript:;" :disabled="!$auth('CDB_MEMBERSHIP_DELETE')">Delete</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
  </a-card>
</div>
</template>

<script>
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import MembershipApi from '@/api/api-cdb-membership'

export default {
  name: 'MembershipList',
  components: {
    STable
  },
  data () {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { name: '', gender: '', registerSite: '', auditStatus : '' },
      // 表头
      columns: [
        {
          title: '#',
          width: '60px',
          scopedSlots: { customRender: 'serial' },
          align:'center',
          fixed: 'left'
        },
        {
          title: 'Name',
          dataIndex: 'fullName',
          align:'center',
          fixed: 'left'
        },
        {
          title: 'No.',
          width: '120px',
          dataIndex: 'membershipCode',
          align:'center'
        },
        {
          title: 'Gender',
          dataIndex: 'gender',
          width: '90px',
          customRender: (value) => (value === 'M') ? 'Male' : 'Female',
          align:'center'
        },
        {
          title: 'DOB',
          dataIndex: 'birthday',
          width: '120px',
          customRender: (value) => this.dateFormatB(value),
          align:'center'
        },
        /* {
          title: 'CDB No.',
          dataIndex: 'customerCode'
        }, */
        {
          title: 'Website',
          dataIndex: 'registerSite',
          align:'center'
        },
        {
          title: 'Last Modified',
          dataIndex: 'writeDate',
          scopedSlots: { customRender: 'writeDate' },
          
        },
        {
          title: 'Coupon',
          dataIndex: 'couponList',
          scopedSlots: { customRender: 'coupon' },
          align:'center'
        },
        {
          title: 'Action',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          align:'center',
          fixed: 'right'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        return MembershipApi.query(Object.assign(parameter, this.queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      MembershipApi.delete(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Delete successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    handleOk () {
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh(false)
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .table-page-search-wrapper .ant-form-inline .ant-form-item > .ant-form-item-label {
  padding-right: 0;
}
::v-deep .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
  padding: 14px;
}
</style>